export const getCurrentYear = () => new Date().getFullYear();

export const getCurrentTimezone = () =>
  new Date().toString()
    .match(/([A-Z]+[+-][0-9]+.*)/)[1];
